import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getSummary({
    devcType,
    devcMassId,
    start,
    end,
    aggregatedUnit,
    showDetails,
    timezone = new Date().getTimezoneOffset() / -60,
  }) {
    return axiosInstance.get(`/summary/aggregated/period/${start}/${end}`, {
      params: {
        devcType,
        devcMassId,
        start,
        end,
        aggregatedUnit,
        showDetails,
        timezone,
      },
      cancelToken: getNewCancelToken(),
    });
  },
};
